export const environment = {
    production: true,
    apiEndPoint: 'https://dev-c-api.greatr.com.au/v1/web'
};